import { xBaseTheme } from "@stoneage/XDL/types";

export default {
    popover: 1260,
    datePicker: 1270,
    dynamicDropdown: 1280,
    stickyFooter: 1284,
    loadingOverlay: 1285,
    menu: 1290,
    drawer: 1290,
    modal: 1300,
    tabGroup: 400,
    toaster: 1400,
    dynamicDropdownInModal: 1310,
} as xBaseTheme["zIndex"];
